module.exports = __webpack_public_path__ + "img/CoS-disabled.26e0c667.svg";